export const LIEN_STATUSES = {
  IN_PROGRESS: 0,
  DONE: 1,
  FINAL_APPROVAL: 2
};

export const TABS = {
  LIEN: 'LIEN',
  USPS: 'USPS',
  NEWSPAPER_ADS: 'NEWSPAPER_ADS',
  APPROVAL: 'APPROVAL',
  LIENS_OVERDUE: 'LIENS_OVERDUE',
  AUCTION: 'AUCTION',
  LIBRARY: 'LIBRARY',
  TENANTS_EMAIL: 'TENANTS_EMAIL',
  NEWSPAPER_STEP: 'NEWSPAPER_STEP'
};
